import {
  Button,
  Dialog,
  Portal,
  Text,
} from '@chakra-ui/react';
import { FC } from 'react';

export type DeleteTeamDialogProps = {
  isOpen: boolean;
  isLoading: boolean;
  teamName?: string;
  error?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
};

const DeleteTeamDialog: FC<DeleteTeamDialogProps> = ({
  isOpen,
  isLoading,
  teamName,
  error,
  onCancel,
  onConfirm,
}) => {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={({ open }) => {
        if (!open) {
          onCancel();
        }
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.CloseTrigger />
            <Dialog.Header flexDirection={'column'}>
              <Dialog.Title>Delete team</Dialog.Title>
              <Dialog.Description>
                Are you sure you want to delete{' '}
                <Text as="span" fontWeight="bold">
                  {teamName}
                </Text>
                ? This action cannot be undone.
              </Dialog.Description>
            </Dialog.Header>
            <Dialog.Body>
              {error ? (
                <Text color="fg.error" fontSize="sm">
                  {error}
                </Text>
              ) : null}
            </Dialog.Body>
            <Dialog.Footer gap="3" justifyContent="flex-end">
              <Button variant="ghost" onClick={onCancel} disabled={isLoading}>
                Cancel
              </Button>
              <Button
                colorPalette="red"
                onClick={onConfirm}
                loading={isLoading}
                disabled={isLoading}
              >
                Delete
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default DeleteTeamDialog;
